<template>
  <section class="testimonialsSection" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="testimonialsSection__bg">
      <div class="testimonialsSection__images js-section-slider-testimonials-images">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(story, index) in stories" :key="index">
            <img
              v-if="story.photo"
              :src="story.photo"
              alt="image"
              class="tw-h-full tw-w-full tw-object-cover"
            />
            <library-iframe v-if="story.video" :src="story.video" class="tw-h-full tw-w-full" :h-ratio="0" />
          </div>
        </div>
      </div>
      <div style="background-color: var(--c-section_primary)"></div>
    </div>

    <div class="container">
      <div class="row justify-end">
        <div class="col-xl-5 col-lg-6 col-md-7">
          <div class="testimonialsSection__content lg:tw-justify-center lg:tw-gap-y-16">
            <div v-html="vars.titleHtml" class="tw-mb-4 md:tw-mb-0"></div>

            <div class="relative overflow-hidden js-section-slider-testimonials">
              <div class="swiper-wrapper">
                <div class="swiper-slide tw-h-full" v-for="(story, index) in stories" :key="index">
                  <div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
                    <!-- Top content section -->
                    <div class="tw-flex tw-flex-col tw-space-y-4">
                      <div class="tw-mb-4 md:tw-hidden">
                        <library-image v-if="story.photo" :src="story.photo" :alt="story.title" />
                        <library-iframe
                          v-if="story.video"
                          :src="story.video"
                          class="tw-h-full tw-w-full"
                          :h-ratio="0"
                        />
                      </div>

                      <h5 v-if="story.title">{{ story.title }}</h5>
                      <p v-if="story.description">{{ story.description }}</p>
                      <p v-if="story.description2">{{ story.description2 }}</p>
                      <h5 v-if="story.author">{{ story.author }}</h5>
                    </div>

                    <!-- Button section with w-fit to make it only as wide as its content -->
                    <nuxt-link
                      v-if="story.button_link"
                      :external="true"
                      :to="story.button_link"
                      :class="`n-${story.button_type}`"
                      class="tw-mt-6 tw-w-fit"
                    >
                      {{ story.button_label }}
                    </nuxt-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mt-20" v-if="stories.length > 1">
              <button class="sliderNav -prev -transparent js-section-slider-testimonials-prev">
                <i class="icon-left-arrow"></i>
              </button>
              <button class="sliderNav -next -transparent ml-20 js-section-slider-testimonials-next">
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme7StoryBox',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    stories() {
      return this.groupedVariables?.stories || [];
    },
  },
});
</script>
